import { render, staticRenderFns } from "./code_owners.vue?vue&type=template&id=2d4cec78"
import script from "./code_owners.vue?vue&type=script&lang=js"
export * from "./code_owners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports